/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * The hook factor method carries no options besides the discriminator.
 * @export
 * @interface HookMethodOptions
 */
export interface HookMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof HookMethodOptions
     */
    method: FactorMethod;
}



/**
 * Check if a given object implements the HookMethodOptions interface.
 */
export function instanceOfHookMethodOptions(value: object): value is HookMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function HookMethodOptionsFromJSON(json: any): HookMethodOptions {
    return HookMethodOptionsFromJSONTyped(json, false);
}

export function HookMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HookMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function HookMethodOptionsToJSON(json: any): HookMethodOptions {
    return HookMethodOptionsToJSONTyped(json, false);
}

export function HookMethodOptionsToJSONTyped(value?: HookMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
    };
}

